export default __webpack_public_path__ + "static/media/defendant-2.64e2600b.jpg";